import React from 'react';
import Box from '@cloudscape-design/components/box';
import Spinner from '@cloudscape-design/components/spinner';
import { AuthProvider, useAuth } from './auth/AuthContext';
import AppShell from './components/AppShell';
import AuthFlow from './screens/AuthFlow';
import LandingScreen from './screens/LandingScreen';

function AppBody() {
    const { user, loading } = useAuth();

    if (loading) {
        return (
            <AppShell>
                <Box textAlign="center" padding="xxl">
                    <Spinner size="large" />
                </Box>
            </AppShell>
        );
    }

    if (user) {
        return <LandingScreen />;
    }

    return (
        <AppShell>
            <AuthFlow />
        </AppShell>
    );
}

function App() {
    return (
        <AuthProvider>
            <AppBody />
        </AuthProvider>
    );
}

export default App;
